import { Buffer } from 'buffer';

export function authHeader(multipart = false) {
    const SecretKey = process.env.VUE_APP_SECRET_KEY;
    const CryptoJS = require("crypto-js");

    const stringToken = Buffer.from(JSON.stringify({
        typ: "JWT",
        alg: "HS256"
    })).toString('base64')
    const localToken = CryptoJS.AES.decrypt(localStorage.getItem('token').toString(), SecretKey).toString(CryptoJS.enc.Utf8)
    
    let user = JSON.parse(localStorage.getItem('user'));
    let token = stringToken + "." + localToken;
    if (user && token) {
        if (multipart) {
            return { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + token };
        }
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}